import Popconfirm from "antd/lib/popconfirm";
import "antd/lib/popconfirm/style/css";

export default Popconfirm;
